/**
 * Change
 * @param {*} props
 * @returns
 */
const staticImageLoader = ({ src, width }) => {
    // const re = new RegExp(`\/_next\/static\/media\/(.*)\.(jpe?g|png)`, "g")
    // const [_, name, ext] = re.exec(src)
    // const basePath  = '.'
    
    // console.log(`Loading: ${src}?w=${width}`)
    // console.log(`${name}, ${ext}`)

    // TODO: Optimize images in nextjs build
    // TODO: Only optimize in production mode
    // sharp(basePath + src)
    //     .resize(width)
    //     .toFile(`${path}${name}-${width}.${ext}`, (err, info) => {
    //         console.log("")
    //     });

    return `${src}?w=${width}`
}

export default staticImageLoader;